"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteTransfer = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 520 320",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M295.650343,72.8039537 C267.442873,71.8220528 240.574909,62.6678319 214.921843,52.6539703 C189.268776,42.6401085 163.853239,31.5411889 136.323309,26.2343389 C118.613816,22.8225196 98.3615998,22.3411206 84.0943209,31.8812247 C70.3605073,41.050728 65.9253461,56.9216099 63.5422743,71.6157389 C61.7471828,82.6955553 60.6919337,94.3293627 65.6060456,104.690901 C69.0210029,111.885141 75.0838177,117.929372 79.2775566,124.817961 C93.8602423,148.792392 83.5608554,178.356399 67.7438011,201.765376 C60.345376,212.745856 51.7281574,223.222013 46.0080066,234.90931 C40.2878556,246.596606 37.6399982,259.991722 42.6436701,271.915896 C47.6084027,283.736914 59.4303076,292.61223 72.2373709,298.855133 C98.2525704,311.539614 128.909308,315.169208 158.80284,317.224704 C224.975913,321.77507 291.503331,319.803628 357.851631,317.832184 C382.406614,317.098624 407.066734,316.361244 431.224539,312.544438 C444.635159,310.42399 458.481895,307.061838 468.216664,298.939188 C480.579823,288.623496 483.644328,271.174695 475.358093,258.249517 C461.47631,236.575102 423.055121,231.195661 413.343714,207.920405 C407.997379,195.113666 413.487788,180.847447 421.256135,168.950016 C437.922062,143.470259 465.856956,121.115774 467.328855,91.9873187 C468.34127,71.982519 454.911181,51.9471544 434.148864,42.4834629 C412.381919,32.5498343 382.204131,33.810641 366.145654,50.231693 C349.612121,67.1685299 320.555779,73.6750565 295.650343,72.8039537 Z",
        fill: "#E6EDFB",
        className: "fill-primary",
        opacity: "0.1",
        fillRule: "nonzero"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(159.000000, 102.000000)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(26.217391, 0.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#00226C",
            className: "fill-dark-primary",
            x: "0",
            y: "0",
            width: "172.597826",
            height: "111.18",
            rx: "4"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#1657E2",
            className: "fill-primary",
            x: "8.73913043",
            y: "0",
            width: "166.043478",
            height: "113.36",
            rx: "4"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            opacity: "0.502511161",
            x: "72.0978261",
            y: "52.32",
            width: "56.8043478",
            height: "10.9"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(0.000000, 17.440000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "0",
            y: "0",
            width: "172.597826",
            height: "104.64",
            rx: "4"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#FFFFFF",
            x: "8.73913043",
            y: "0",
            width: "174.782609",
            height: "104.64",
            rx: "4"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "26.2173913 17.44 69.9130435 17.44 69.9130435 61.04 26.2173913 61.04"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "78.6521739",
            y: "26.16",
            width: "87.3913043",
            height: "8.72"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "78.6521739",
            y: "43.6",
            width: "61.173913",
            height: "8.72"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "26.2173913",
            y: "78.48",
            width: "34.9565217",
            height: "8.72"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "69.9130435",
            y: "78.48",
            width: "52.4347826",
            height: "8.72"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "131.086957",
            y: "78.48",
            width: "34.9565217",
            height: "8.72"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(61.173913, 87.200000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#1657E2",
            className: "fill-primary",
            x: "0",
            y: "95.92",
            width: "87.3913043",
            height: "34.88"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#00226C",
            className: "fill-dark-primary",
            x: "0",
            y: "69.76",
            width: "87.3913043",
            height: "26.16"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#FEC9C8",
            x: "0",
            y: "34.88",
            width: "87.3913043",
            height: "34.88"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fillOpacity: "0.102272727",
            fill: "#000000",
            x: "0",
            y: "34.88",
            width: "87.3913043",
            height: "10.9"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M69.9130435,0 C79.5660204,-1.7732231e-15 87.3913043,7.82528394 87.3913043,17.4782609 L87.3913043,65.4 L87.3913043,65.4 L52.4347826,65.4 L52.4347826,17.4782609 C52.4347826,7.82528394 60.2600665,1.7732231e-15 69.9130435,0 Z",
            fill: "#FEC9C8"
          })]
        })]
      })]
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteTransfer')(IllustrationMySiteTransfer);